import { useMutation } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import { PricebookItem, SearchPricebookItemsParams } from '../../../admin/components/tools/PricingWizard/types';

export function useSearchPricebookItemsMutation() {
	const userSession = useAdminUserSession();
	return useMutation({
		mutationFn: async (params: SearchPricebookItemsParams) => {
			const searchParams = new URLSearchParams();

			// Required parameter
			searchParams.set('productCode', params.productCode);

			// Optional parameters - only add if defined
			if (params.discount !== undefined) {
				searchParams.set('discount', params.discount);
			}
			if (params.hasFacebookPremium !== undefined) {
				searchParams.set('hasFacebookPremium', params.hasFacebookPremium);
			}
			if (params.hasHandwrittenCards !== undefined) {
				searchParams.set('hasHandwrittenCards', params.hasHandwrittenCards);
			}
			if (params.hasGoogleLocalServiceAds !== undefined) {
				searchParams.set('hasGoogleLocalServiceAds', params.hasGoogleLocalServiceAds);
			}
			if (params.hasGooglePpc !== undefined) {
				searchParams.set('hasGooglePpc', params.hasGooglePpc);
			}
			if (params.additionalUsers !== undefined) {
				searchParams.set('additionalUsers', params.additionalUsers);
			}
			if (params.isSplitBilling !== undefined) {
				searchParams.set('isSplitBilling', params.isSplitBilling);
			}

			return userSession.webServiceHelper.callAsync<PricebookItem[]>(
				`admin/BillingUtilities/SearchPricebookItems?${searchParams.toString()}`,
				'GET'
			);
		},
	});
}
